/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  ListItem, ListItemButton, ListItemIcon, ListItemText,
} from '@mui/material';
import Theme from "../Theme";

const activeStyle = {
  borderStyle: 'solid',
  borderWidth: '1px',
  borderRadius: '30px',
  borderColor: Theme.palette.primary.main,
};

const CustomLink = (to) => React.useMemo(
  () => React.forwardRef((linkProps, ref) => (
    <NavLink
      ref={ref}
      to={to}
      style={({ isActive }) => (isActive ? activeStyle : undefined)}
      {...linkProps}
    />
  )),
  [to],
);

function ListItemLink({ icon, primary, to }) {
  const customLink = CustomLink(to);
  return (
    <ListItem disablePadding>
      <ListItemButton component={customLink}>
        {icon && <ListItemIcon>{icon}</ListItemIcon>}
        <ListItemText primary={primary} />
      </ListItemButton>
    </ListItem>
  );
}

export default ListItemLink;
